
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import { MessageBox } from "element-ui";
import AuditLogDetail from "./components/audit-detail.vue";
import { AuditLogListDto } from "@/api/appService";

@Component({
  name: "AuditLogList",
  components: { AuditLogDetail }
})
export default class AuditLogList extends ElementTableView {


  tableItems: AuditLogListDto[] = [];

  auditLogDetailShow:boolean = false;
  auditLogDetail:AuditLogListDto = {};

  async created() {
    await this.fetchData();
  }

  defaultQuery: {
    /**  */
    startDate?: string;
    /**  */
    endDate?: string;
    /**  */
    userName?: string;
    /**  */
    serviceName?: string;
    /**  */
    methodName?: string;
    /**  */
    browserInfo?: string;
    /**  */
    hasException?: boolean;
    /**  */
    minExecutionDuration?: number;
    /**  */
    maxExecutionDuration?: number;
    /**  */
  } = {
    startDate: undefined,
    endDate: undefined,
    userName: undefined,
    serviceName: undefined,
    methodName: undefined,
    browserInfo: undefined,
    hasException: undefined,
    minExecutionDuration: undefined,
    maxExecutionDuration: undefined
  };

  queryForm = {
    ...this.defaultQuery
  };

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.auditLog
      .getAuditLogs(
        Object.assign(this.queryForm, {
          sorting: this.table.sorting,
          skipCount: this.skipCount,
          maxResultCount: this.table.pagesize
        })
      )
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  // 新建
  handleCreate() {
    (this.$refs.editForm as any).show = true;
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = this.defaultQuery;
    await this.fetchData();
  }

  handleView(row: AuditLogListDto) {
    (this.$refs.auditLogDetail as any).show = true;
    this.auditLogDetail = row;
  }
}
